import { render, staticRenderFns } from "./FolderTreeSelect.vue?vue&type=template&id=0a725d10&"
import script from "./FolderTreeSelect.vue?vue&type=script&lang=js&"
export * from "./FolderTreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./FolderTreeSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VTreeview})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a725d10')) {
      api.createRecord('0a725d10', component.options)
    } else {
      api.reload('0a725d10', component.options)
    }
    module.hot.accept("./FolderTreeSelect.vue?vue&type=template&id=0a725d10&", function () {
      api.rerender('0a725d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FolderTreeSelect.vue"
export default component.exports